/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

import * as go from 'gojs';

/**
 * LayeredDigraphLayout that fans out multiple parallel links between the
 * same two nodes as Bezier curves while keeping single links straight.
 */
export class CurvedMultiLinkDigraphLayout extends go.LayeredDigraphLayout {
  constructor(init?: Partial<go.LayeredDigraphLayout>) {
    super();
    if (init) Object.assign(this, init);
  }

  override commitLinks() {
    super.commitLinks();
    this.network?.edges.each((e) => {
      const from = e.fromVertex as go.LayeredDigraphVertex | null;
      const to = e.toVertex as go.LayeredDigraphVertex | null;
      if (!from?.node) return;
      if (!to?.node) return;

      const l = e.link;
      if (!l?.fromNode || !l?.toNode) return;

      const between = l.fromNode.findLinksBetween(l.toNode);
      const total = between.count;
      if (total > 1) {
        const arr: go.Link[] = [];
        between.each((link) => arr.push(link));
        const idx = arr.indexOf(l);
        const step = 20;
        l.curve = go.Curve.Bezier;
        l.curviness = (idx - (total - 1) / 2) * step;
      } else {
        l.curve = go.Curve.None;
      }
      l.invalidateRoute();
      l.updateRoute();
    });
  }
}
